import React from 'react';
import PropTypes from 'prop-types';
import color from '../caveatColor';

const containerStyle = {
  width: 45,
  height: 45,
  textAlign: 'center',
  position: 'absolute',
  overflow: 'hidden',
  left: 16,
  top: 16,
  userSelect: 'none'
}

const containerStyleLessThanThree = {
  ...containerStyle,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const circleStyle = {
  borderRadius: 24,
  width: 22,
  height: 22,
  minWidth: 22,
  color: 'white',
  textAlign: 'center',
  lineHeight: '21px',
  display: 'inline-block',
  fontSize: '13px'
}

const criteriaContainer = {
  width: 45,
  height: 45,
  textAlign: 'center',
  position: 'absolute',
  overflow: 'hidden',
  left: 16,
  top: 16,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  userSelect: 'none'
}

const criteriaStyle = {
  backgroundColor: 'black',
  color: 'white',
  width: '45%',
  float: 'left',
  padding: '2px 6px',
  borderRadius: '3px 0px 0px 3px',
  fontSize: '13px'
}

const CircleIcon = (props) => {
  if (props.n > 0) {
    return <div style={{...circleStyle, backgroundColor: color(props.score).primary}}>{props.n}</div>
  } else {
    return null;
  }
}

const InfluenceAvatar = (props) => {
  var numCavs = props.redCaveats + props.orangeCaveats + props.yellowCaveats;
  var numCrit = props.metCriteria + props.unmetCriteria;

  if(numCavs > 0 || numCrit > 0){
    let cs = containerStyleLessThanThree;
    if (props.redCaveats && props.orangeCaveats && props.yellowCaveats) {
      cs = containerStyle;
    }
    if (numCavs > 0 && numCrit === 0) { //caveats only

      return (
        <div style={cs} onClick={props.onClick}>
          <CircleIcon score={-3} n={props.redCaveats} />
          <CircleIcon score={-2} n={props.orangeCaveats} />
          <CircleIcon score={-1} n={props.yellowCaveats} />
        </div>
      )
    } else if(numCrit > 0 && numCavs === 0) { //criteria only
      return (
        <div style={criteriaContainer}>
          <div style={criteriaStyle}>{props.unmetCriteria}</div>
          <div style={{...criteriaStyle, backgroundColor: 'green',   borderRadius: '0px 3px 3px 0px'}}>{props.metCriteria}</div>
        </div>
      )
    } else { //both caveats and criteria
        return (
          <div style={{display:'flex',
          alignItems: 'center',
          justifyContent: 'center', flexDirection:'column', position: 'absolute', left: 2, top: 2}}>
            <div style={{...criteriaContainer, position:'relative', height:'40%', marginBottom:5}}>
              <div style={criteriaStyle}>{props.unmetCriteria}</div>
              <div style={{...criteriaStyle, backgroundColor: 'green',   borderRadius: '0px 3px 3px 0px'}}>{props.metCriteria}</div>
            </div>
            <div style={{...cs, position:'relative', height:'40%'}} onClick={props.onClick}>
              <CircleIcon score={-3} n={props.redCaveats} />
              <CircleIcon score={-2} n={props.orangeCaveats} />
              <CircleIcon score={-1} n={props.yellowCaveats} />
            </div>
          </div>
        )
    }
  } else { //No options affected or only pos attrs
    //NOTE: this also includes only pos attributes at this time
    return (
      <div style={{...containerStyleLessThanThree}}>

      </div>
    )
  }
}

export default InfluenceAvatar;

InfluenceAvatar.propTypes = {
  redCaveats: PropTypes.number.isRequired,
  orangeCaveats: PropTypes.number.isRequired,
  yellowCaveats: PropTypes.number.isRequired,
  metCriteria: PropTypes.number.isRequired,
  unmetCriteria: PropTypes.number.isRequired,
  display: PropTypes.oneOf(['Caveat', 'Criteria']).isRequired,
}
